import { For } from "solid-js";
import { Skeleton, PageContainer } from "@fleet/ui";

/**
 * Granular skeleton for the <Outlet /> content region, shown while the local
 * PowerSync database is still initializing (so the static shell — header,
 * sidebar, background — is already visible and interactive). Mirrors the
 * structure of the default day view (heading, composer, entry cards) so the
 * transition to real content is visually stable.
 */
export function AppContentSkeleton() {
  return (
    <PageContainer maxWidth="2xl" class="flex flex-col gap-6 pb-16">
      {/* Day heading row */}
      <header class="flex flex-col gap-3 pt-2">
        <div class="flex items-center justify-between gap-2">
          <Skeleton class="h-8 w-16" />
          <Skeleton class="h-7 w-20 rounded-full" />
        </div>
        <div class="flex flex-col gap-2">
          <Skeleton class="h-4 w-12" />
          <Skeleton class="h-8 w-64" />
        </div>
      </header>

      {/* Composer placeholder */}
      <Skeleton class="h-28 w-full rounded-xl" />

      {/* Entry cards placeholders */}
      <div class="flex flex-col gap-4">
        <For each={Array.from({ length: 3 })}>
          {() => (
            <div class="flex flex-col gap-3 rounded-xl border border-border/40 p-4">
              <div class="flex items-center justify-between gap-2">
                <Skeleton class="h-4 w-24" />
                <Skeleton class="h-4 w-12" />
              </div>
              <Skeleton class="h-4 w-full" />
              <Skeleton class="h-4 w-5/6" />
              <Skeleton class="h-4 w-2/3" />
            </div>
          )}
        </For>
      </div>
    </PageContainer>
  );
}
